import { useMutation } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import { ProposeGenieDocumentSuiteResult } from "@/types/genie-documents/genie-document";

/**
 * Propose a suite of branded documents from everything attached to a genie.
 * The swarm's planner step — cheap worker reads the knowledge, returns a
 * reviewable checklist. Generates and saves nothing.
 */
export const useProposeGenieDocumentSuite = () => {
  return useMutation<ProposeGenieDocumentSuiteResult, Error, string>({
    mutationFn: async (agentId) =>
      ApiService.invoke<ProposeGenieDocumentSuiteResult>({
        resource: "genie-documents",
        action: "propose-suite",
        data: { agentId },
      }),
  });
};
